import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  Input,
  Renderer2,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'app-dynamic-content-viewer',
  imports: [],
  template: `
    <div #template></div>
  `,
  styles: `
    :host {
      display: block;
      overflow: auto;
      text-align: justify;
    }
  `
})
export class DynamicContentViewerComponent implements AfterViewInit {
  private renderer = inject(Renderer2);
  private readonly allowedActionLabel = 'consultar convocatoria';

  @Input({ required: true }) content?: string;
  @Input() keepOnlyConsultarConvocatoriaActions = false;
  @ViewChild('template') el!: ElementRef;

  ngAfterViewInit() {
    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.content);
    if (this.keepOnlyConsultarConvocatoriaActions) {
      this.removeUnexpectedActions();
    }
  }

  private removeUnexpectedActions() {
    // TEMPORAL: ocultar acciones dinámicas hasta actualizar contenido en BD de prod.
    const container = this.el.nativeElement as HTMLElement;
    const actions = container.querySelectorAll('a, button');

    actions.forEach((action: Element) => {
      const label = action.textContent?.trim().replace(/\s+/g, ' ').toLowerCase();

      if (label !== this.allowedActionLabel) {
        action.remove();
      }
    });
  }
}
